import React, { useEffect, useState, useCallback } from "react";
import { useLazyQuery, useQuery } from "@apollo/react-hooks";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "rc-time-picker/assets/index.css";
import map from "../../images/map-icon.svg";
import UploadImage from "../Common/upload-image/UploadImage";
import ImageKit from "imagekit-javascript";
import { GET_CATEGORIES } from "../../query/GetCategory";
import { hasuraClient } from "../../apolloClient";
import { IS_EVENT_NAME_EXIST } from "../../query/IsEventNameExist";
import moment from "moment";
import DeletePost from "../Popup/DeletePost";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";

const EventInformation = (props) => {
  const [gmapsLoaded, setGmapsLoaded] = useState(false);

  const initMap = () => {
    setGmapsLoaded(true);
  };
  useEffect(() => {
    window.initMap = initMap;
    const gmapScriptEl = document.createElement(`script`);
    gmapScriptEl.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_URL}&callback=initMap&libraries=places&callback=initMap`;
    document
      .querySelector(`body`)
      .insertAdjacentElement(`beforeend`, gmapScriptEl);
  }, []);

  const [getCategories, { data: allCategories }] = useLazyQuery(
    GET_CATEGORIES,
    {
      client: hasuraClient,
      variables: {},
    }
  );

  const { step1Data, setStep1Value } = props;

  const value = {
    name: "",
    location_text: "",
    location: "",
    categories: "",
    description: "",
    date_time: "",
    start_date_time: "",
    council_url: "",
    end_date_time: "",
    image_path: "",
    image_url: "",
  };
  const [name, setName] = useState(step1Data ? step1Data.name : "");
  const [councilUrl, setCouncilUrl] = useState(step1Data ? step1Data.council_url : "");

  const [description, setDescription] = useState(
    step1Data ? step1Data.description : ""
  );
  const [categories, setCategories] = useState(
    step1Data ? step1Data.categories : ""
  );
  const [location, setLocation] = useState(
    step1Data ? step1Data.location_text : ""
  );

  const [locationLocal, setLocationLocal] = useState(
    step1Data ? step1Data.location_text : ""
  );
  const [locationG, setLocationG] = useState(
    step1Data ? step1Data.location : ""
  );
  const [date, setDate] = useState(
    step1Data
      ? step1Data.date_time.length > 0
        ? new Date(step1Data.date_time)
        : ""
      : ""
  );
  const [start, setStart] = useState(
    step1Data
      ? step1Data.start_date_time.length > 0
        ? new Date(step1Data.start_date_time)
        : ""
      : ""
  );
  const [end, setEnd] = useState(
    step1Data
      ? step1Data.end_date_time.length > 0
        ? new Date(step1Data.end_date_time)
        : ""
      : ""
  );

  const handleChange = (valueVal) => {
    setLocationLocal(valueVal);
  };

  useEffect(() => {
    if (locationG && location && locationLocal) {
      setLocationError(false);
    }
  }, [location, locationG, locationLocal]);

  const handleSelect = (valueVal) => {
    props.setLocation_text(valueVal);
    setLocation(valueVal);
    setLocationLocal(valueVal);
    geocodeByAddress(valueVal)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        setLocationG({
          type: "Point",
          coordinates: [latLng?.lat, latLng?.lng],
        });
      })
      .catch((error) => console.error(error));
  };

  const [nameError, setNameError] = useState(false);
  const [existNameError, setExistNameError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [categoriesError, setCategoriesError] = useState(false);
  const [locationError, setLocationError] = useState(false);
  const [dateError, setDateError] = useState(false);
  const [startError, setStartError] = useState(false);
  // const [councilUrlError, setCouncilUrlError] = useState(false);
  const [startFutureError, setStartFutureError] = useState(false);

  const [endError, setEndError] = useState(false);
  const [startEndError, setStartEndError] = useState(false);

  const profileId = localStorage.getItem("profile_id");

  const [imageLoading, setImageLoading] = useState(false);
  const [uploadedImg, setUploadedImg] = useState(
    step1Data ? step1Data.image_url : ""
  );
  const [imageError, setImageError] = useState("");

  const [imageName, setImageName] = useState(
    step1Data ? step1Data.image_path : ""
  );

  const { refetch } = useQuery(IS_EVENT_NAME_EXIST, {
    client: hasuraClient,
    variables: {
      name: name.trimStart().trimEnd(),
    },
    onCompleted: (res) => {
      if (res?.is_name_exist?.aggregate?.count === 1) {
        if (props?.data?.events_by_pk?.name !== name) {
          setExistNameError(true);
        }
      } else {
        setExistNameError(false);
      }
    },
  });

  useEffect(() => {
    if (uploadedImg) {
      setImageError(false);
    }
  }, [uploadedImg]);

  useEffect(() => {
    if (step1Data) {
      setName(step1Data.name);
      setDescription(step1Data.description);
      setLocation(step1Data.location_text);
      setLocationLocal(step1Data.location_text);
      setLocationG(step1Data?.location);
      setCategories(step1Data.categories);
      setDate(new Date(step1Data.date_time));
      setStart(new Date(step1Data.start_date_time));
      setCouncilUrl(step1Data?.council_url)
      setEnd(new Date(step1Data.end_date_time));
      setUploadedImg(step1Data.image_url);
      setImageName(step1Data.image_path);
    }
  }, [step1Data]);

  useEffect(() => {
    getCategories();
  }, []);

  useEffect(() => {
    refetch();
  }, [name]);

  const handleNext = () => {
    let nameErrorVal = false;
    let descriptionErrorVal = false;
    let categoriesErrorVal = false;
    let locationErrorVal = false;
    let dateErrorVal = false;
    let startErrorVal = false;
    let endErrorVal = false;
    let imageErrorVal = false;
    let councilUrlErrorVal = false;
    let startEndTimeErrorVal = false;
    let startFutureErrorVal = false;

    if (name === "") {
      nameErrorVal = true;
      setNameError(true);
    } else {
      nameErrorVal = false;
      setNameError(false);
    }
    // var urlPattern = new RegExp(
    //   '((http|https)://)(www.)?[a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)',
    // );
    // if(!urlPattern.test(councilUrl)){
    //   councilUrlErrorVal = true;
    //   setCouncilUrlError(true)
    // }else{
    //   councilUrlErrorVal = false;
    //   setCouncilUrlError(false);
    // }

    if (description === "") {
      descriptionErrorVal = true;
      setDescriptionError(true);
    } else {
      descriptionErrorVal = false;
      setDescriptionError(false);
    }

    if (categories === "") {
      categoriesErrorVal = true;
      setCategoriesError(true);
    } else {
      categoriesErrorVal = false;
      setCategoriesError(false);
    }

    if (location === "" || !locationLocal) {
      locationErrorVal = true;
      setLocationError(true);
    } else {
      locationErrorVal = false;
      setLocationError(false);
    }

    if (date === "" || value.startDate === NaN) {
      dateErrorVal = true;
      setDateError(true);
    } else {
      dateErrorVal = false;
      setDateError(false);
    }

    if (start === "") {
      startErrorVal = true;
      setStartError(true);
    } else {
      startErrorVal = false;
      setStartError(false);
    }

    if (moment(date).unix() <= moment().unix()) {
      if (
        moment(
          moment(date).format("YYYY-MM-DD") +
            " " +
            moment(start).format("HH:mm:ss")
        ).unix() <= moment().unix()
      ) {
        startFutureErrorVal = true;
        setStartFutureError(true);
      } else {
        setStartFutureError(false);
        startFutureErrorVal = false;
      }
    }

    if (end === "") {
      endErrorVal = true;
      setEndError(true);
    } else {
      endErrorVal = false;
      setEndError(false);
    }

    if (moment(end).unix() <= moment(start).unix()) {
      startEndTimeErrorVal = true;
      setStartEndError(true);
    } else {
      startEndTimeErrorVal = false;
      setStartEndError(false);
    }

    if (uploadedImg === "") {
      imageErrorVal = true;
      setImageError(true);
    } else {
      imageErrorVal = false;
      setImageError(false);
    }

    if (
      nameErrorVal === false &&
      descriptionErrorVal === false &&
      locationErrorVal === false &&
      dateErrorVal === false &&
      startErrorVal === false &&
      endErrorVal === false &&
      categoriesErrorVal === false &&
      councilUrlErrorVal === false &&
      imageErrorVal === false &&
      startEndTimeErrorVal === false &&
      startFutureErrorVal === false &&
      existNameError === false
    ) {
      setNameError(false);
      setExistNameError(false);
      setDescriptionError(false);
      setLocationError(false);
      setCategoriesError(false);
      setStartError(false);
      setDateError(false);
      setEndError(false);
      setStartEndError(false);
      // setCouncilUrlError(false)
      setStartFutureError(false);

      const values = value;
      values.name = name;
      values.description = description;
      values.categories = categories;
      values.location_text = location;
      value.location = locationG;
      values.council_url=councilUrl;
      values.date_time = date ? new Date(date).toISOString() : "";
      values.start_date_time = `${moment(date).format("YYYY-MM-DD")}T${moment(
        start
      ).format("HH:mm:ss")}`;
      values.end_date_time = `${moment(date).format("YYYY-MM-DD")}T${moment(
        end
      ).format("HH:mm:ss")}`;

      values.image_path = `/dev/business_profile/${profileId}/${imageName}`;
      values.image_url = uploadedImg;

      setStep1Value(values);
      if (props?.modalShowD) {
        props.onPressYes(values, false);
      } else {
        props.handleNext(value, 1);
      }
    }
  };

  const imageKit = new ImageKit({
    urlEndpoint: process.env.REACT_APP_URL_END_POINT,
    publicKey: process.env.REACT_APP_PUBLIC_KEY,
    authenticationEndpoint: process.env.REACT_APP_AUTHENTICATION_END_POINT,
  });

  const handleImageUpload = async (imgObj) => {
    setImageLoading(true);

    await imageKit.upload(
      {
        tags: ["tag1"],
        folder: "/dev/rahim",
        file: imgObj,
        fileName: imgObj.name,
      },
      (err, result) => {
        if (result) {
          setUploadedImg(
            imageKit.url({
              src: result.url,
            })
          );

          setImageName(imgObj.name);

          setImageLoading(false);
        }
      }
    );
  };

  const onImageDrop = useCallback((acceptedFiles) => {
    handleImageUpload(acceptedFiles[0]);
  }, []);

  return (
    <div className="event-list-cover typeofevent-row">
      <DeletePost
        title={"Your changes will be saved. Are you sure you want to exit?"}
        cancelButtonText={"No"}
        deletePostHandler={handleNext}
        show={props?.modalShowD}
        onHide={props?.onPressNo}
      />
      <div className="title">
        <h3>Event information</h3>
        <p>Please enter in your event’s information.</p>
      </div>

      <div className="eventinformation">
        <div className="eventinfo-left">
          <div className="form-group">
            <label>Event Name</label>
            <input
              type="text"
              defaultValue={name ? name : null}
              className="lg-form-control"
              onChange={(event) => {
                setName(event.target.value);
                setNameError(false);
              }}
            />
            <p hidden={!existNameError} className="error-message">
              Event Name exist
            </p>
            <p hidden={!nameError} className="error-message">
              Event Name required
            </p>
          </div>
          <div className="form-group">
            <label>Description</label>
            <textarea
              defaultValue={description ? description : null}
              className="lg-form-control"
              rows="6"
              onChange={(event) => {
                setDescription(event.target.value);
                setDescriptionError(false);
              }}
            ></textarea>
            <p hidden={!descriptionError} className="error-message">
              Event Description required
            </p>
          </div>
          {/* <div className="form-group">
            <label>Council Url</label>
            <input
              type="url"
              className="lg-form-control"
              defaultValue={councilUrl ? councilUrl : null}
              onChange={(event) => {
                setCouncilUrl(event.target.value);
              }}
            />
            <p hidden={!councilUrlError} className="error-message">
              Invalid Url required
            </p>
          </div> */}
          <div className="form-group select">
            <label>Event category</label>
            <select
              className="lg-form-control"
              onBlur={(event) => {
                setCategories(event.target.value);
                setCategoriesError(false);
              }}
              onClick={() => {
                setCategoriesError(false);
              }}
            >
              <option value="">Select</option>
              {allCategories
                ? allCategories.categories.map((category) => {
                    return (
                      <option
                        value={category.id}
                        selected={categories === category.id ? true : false}
                      >
                        {category.name}
                      </option>
                    );
                  })
                : null}
            </select>
            <p hidden={!categoriesError} className="error-message">
              Event Category required
            </p>
          </div>

          <div className="form-group map-input">
            <label>Location</label>

            {gmapsLoaded && (
              <PlacesAutocomplete
                onSelect={handleSelect}
                value={locationLocal}
                onChange={handleChange}
              >
                {({
                  getInputProps,
                  suggestions,
                  getSuggestionItemProps,
                  loading,
                }) => (
                  <div>
                    <img
                      src={map}
                      alt="map-icon"
                      style={{
                        marginRight: "10px",
                        marginTop: "13px",
                        position: "absolute",
                        marginLeft: "10px",
                      }}
                    />

                    <input
                      type="text"
                      className="lg-form-control"
                      style={{ width: "100%", paddingLeft: "30px" }}
                      {...getInputProps({
                        placeholder: "Enter Location...",
                      })}
                    />

                    <div
                      className="suggestion-box"
                      style={{
                        border:
                          suggestions && suggestions.length > 0
                            ? "1px solid #e8e9eb"
                            : "",
                      }}
                    >
                      {loading && <div>Loading...</div>}
                      {suggestions
                        // .filter(
                        //   (item) =>
                        //     item.terms[item.terms.length - 1].value ===
                        //     "Australia"
                        // )
                        .map((suggestion, index) => {
                          const style = suggestion.active
                            ? {
                                backgroundColor: "#e9ebed",
                                cursor: "pointer",
                              }
                            : {
                                backgroundColor: "#ffffff",
                                cursor: "pointer",
                              };

                          return (
                            <div
                              key={index}
                              {...getSuggestionItemProps(suggestion, {
                                style,
                              })}
                            >
                              {suggestion.description}
                            </div>
                          );
                        })}
                    </div>
                    <p hidden={!locationError} className="error-message">
                      Event Location required
                    </p>
                  </div>
                )}
              </PlacesAutocomplete>
            )}
          </div>
        </div>
        <div className="eventinfo-right">
          <div className="form-group event-date-row">
            <label>Date</label>
            <DatePicker
              selected={date}
              dropdownMode="select"
              autoComplete="off"
              onChange={(valueVal) => {
                setDate(valueVal);
                setDateError(false);
              }}
              className="react-time-input"
              calendarClassName="react-time-picker"
              popperClassName="react-time-propper"
              minDate={new Date()}
            />
            <p hidden={!dateError} className="error-message">
              Event Date required
            </p>
          </div>
          <div className="form-group">
            <label>Time</label>
            <div className="time-group">
              <div className="time-left time-input" style={{ marginRight: 21 }}>
                <DatePicker
                  selected={start}
                  dropdownMode="select"
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={30}
                  dateFormat="h:mm aa"
                  autoComplete="off"
                  onChange={(valueVal) => {
                    setStart(valueVal);
                    setStartError(false);
                    setStartFutureError(false);
                    setStartEndError(false);
                  }}
                  className="react-time-input"
                  calendarClassName="react-time-picker"
                  popperClassName="react-time-propper"
                />
                <p hidden={!startError} className="error-message">
                  Event Start Time required
                </p>
                {startFutureError ? (
                  <p hidden={!startFutureError} className="error-message">
                    Select future time
                  </p>
                ) : (
                  <p hidden={!startEndError} className="error-message">
                    Select a time before 12 am
                  </p>
                )}
              </div>
              <span></span>
              <div className="time-right time-input" style={{ marginLeft: 21 }}>
                <DatePicker
                  selected={end}
                  dropdownMode="select"
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={30}
                  dateFormat="h:mm aa"
                  autoComplete="off"
                  onChange={(valueVal) => {
                    setEnd(valueVal);
                    setEndError(false);
                  }}
                  className="react-time-input"
                  calendarClassName="react-time-picker"
                  popperClassName="react-time-propper"
                />
                <p hidden={!endError} className="error-message">
                  Event End Time required
                </p>
              </div>
            </div>
          </div>
          <div className="form-group add-image-group">
            <label>Add images</label>
            <div className="image-group">
              <UploadImage
                titleNeeded={false}
                onImageDrop={onImageDrop}
                disabled={!!uploadedImg}
                uploadedImg={uploadedImg}
                setUploadedImg={setUploadedImg}
                loading={imageLoading}
              />
            </div>
            <p hidden={!imageError} className="error-message">
              Image required
            </p>
          </div>
        </div>
      </div>

      <div className="event-button-row">
        <button className="next-btn" onClick={handleNext}>
          Next
        </button>
      </div>
    </div>
  );
};

export default EventInformation;
